<app-header></app-header>
<router-outlet></router-outlet>
<app-toaster></app-toaster>
<app-tour-modal />

<app-login-modal
  *ngIf="loginModal.visible()"
  [redirectUri]="loginModal.redirectUri()"
  (visibleChange)="!$event && loginModal.close(true)"
></app-login-modal>

<!-- Full-screen overlay shown during logout after password change -->
<div *ngIf="isLoggingOutAfterPasswordChange" class="logout-overlay">
  <div class="logout-overlay__content">
    <div class="logout-overlay__spinner"></div>
    <p class="logout-overlay__message">Password changed successfully. Logging out...</p>
  </div>
</div>

<!-- Full-screen loader while an export download is in progress -->
<div *ngIf="exportLoader.visible()" class="export-loader-overlay" aria-live="polite" aria-busy="true">
  <div class="export-loader-overlay__spinner"></div>
</div>
